import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_189y0nghd9: FaireBrandEntity = {
  token: "b_189y0nghd9",
  type: "brand",
  name: "ChappyWrap",
  avatarUrl:
    "https://cdn.faire.com/fastly/a150caaaf5c7a34d16602179a92ce730f346af9128104f041bf1f5a53e7da177.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a9391cd5fa8a94eb3c66d8674c5447a7625f642e0e2fb76328da292f9646a000.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a150caaaf5c7a34d16602179a92ce730f346af9128104f041bf1f5a53e7da177.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a9391cd5fa8a94eb3c66d8674c5447a7625f642e0e2fb76328da292f9646a000.jpeg",
  location: "Portland, ME, USA",
  minimumOrderDollars: 800,
  rating: 5,
  reviewCount: 100,
  isTopShop: true,
  isInsider: true,
  description:
    "The best blanket you will ever own. At ChappyWrap, we have one simple mission: to provide comfort to everyone, everywhere with the best blankets in the world. Out blankets are uniquely woven with a plush, natural-cotton blend and high-performance fibers. They are produced with unparalleled craftsmanship in our factories in Germany and Poland. The end result? A blanket that lasts a lifetime.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:43:53.609Z",
    importedBy: "entity-db-cli",
  },
};
